import etZoneDataConfig from '@/api/config/etZoneDataConfig'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { NotifyService } from '@/helpers'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function deleteEtZone(interfaceId: string, id: string): Promise<void> {
  await etZoneDataConfig.delete(interfaceId, id)
}

function useDeleteEtZone() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeModal } = useConfigUI()

  const { mutate } = useMutation(
    (payload: any) => deleteEtZone(payload.interfaceId, payload.id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.etZone])
        toast.success(t('deleteMicroClimateSuccess'))
        closeModal()
      },
      onError: (error: any) => {
        NotifyService.error(error)
        closeModal()
      },
    },
  )

  return mutate
}

export default useDeleteEtZone
